module.exports = __webpack_public_path__ + "img/calendar-gray-icon.17eb6f4c.svg";